import Vue from 'vue'

import Router from 'vue-router'

//user模块
import user from './user'

//课程模块
import course from './course'

//人员模块
import person from './person'

//组织模块
import organization from './organization'

//学生模块
import student from './student'

//老师模块
import teacher from './teacher'

//设置模块
import setting from './setting'

//教务
import education from './education'

//报表
import report from './report'

//财务
import finance from './finance.js'

//总览
import synopsis from './synopsis.js'


//活动模块
import activity from './activity'

//广告模块
import banner from './banner'

//APP模块
import appModule from './appModule'

//意见反馈模块
import feedback from './feedback'

//首页
import dashboard from './dashboard'

//操作日志模块
import operateLog from './operateLog'

import BasicLayout from '../layouts/BasicLayout'

//异常页面模块
import exception from './exception'

//站点首页大图模块
import webSiteBanner from './webSiteBanner'

//站点首页课程模块
import webSiteCourse from './webSiteCourse'

//站点首页风采模块
import webSiteWonderful from './webSiteWonderful'

//站点课程大图模块
import webSiteCourseBanner from './webSiteCourseBanner'

//站点课程方大图模块
import webSiteOrgBanner from './webSiteOrgBanner'

//资讯模块
import portalList from './portalList'

// 企业微信
import qyweixin from './qyweixin'

Vue.use(Router)

//菜单页面，基本布局（basicLayout）中的非白名单路由，会直接访问listMyPerms权限菜单接口
let menuPageList = [
  ...course,
  ...person,
  ...organization,
  ...student,
  ...teacher,
  ...setting,
  ...education,
  ...report,
  ...activity,
  ...banner,
  ...finance,
  ...synopsis,
  ...appModule,
  ...feedback,
  ...dashboard,
  ...operateLog,
  ...webSiteBanner,
  ...webSiteCourse,
  ...webSiteWonderful,
  ...webSiteCourseBanner,
  ...webSiteOrgBanner,
  ...portalList,
]

//初始静态页面 非基本布局（basicLayout）的白名单路由集合，不会访问listMyPerms权限菜单接口
let routes = [
  {
    path: '/',
    name: 'basicLayout',
    component: BasicLayout,
    redirect: '/portal',
    // redirect: '/courseList',
    meta: { title: '首页' },
    children: [],
  },
  ...user,
  ...qyweixin,
  ...exception,
]

// 初始化路由
const router = new Router({
  routes: routes,
})

//处理菜单数据和判断是否拦截手动输入path的功能模块
import menuTreeData from '../utils/menuTreeData'
import permission from '../api/permission'
//路由钩子判断访问的地址是否有权限访问
router.beforeEach((to, from, next) => {
  // console.log(to.path, from,window.menuList,'1到哪里去')
  //第二种方法 动态路由设置，根据角色的权限页面动态设置路由，没有权限的页面不配置在路由中
  var menuList = window.menuList
  var menuListFlag = window.menuListFlag
  var toPageFlag = true
  //如果登录状态进行请求listMyPerms权限菜单，获取接口数据及处理后放行
  if (Vue.ls.get('token')) {
    // console.log(menuList,menuListFlag,window.menuList,'2beforeEachbeforeEach')
    routeUtilsMenthed(menuList, menuListFlag, (res) => {})
    next()
  } else {
    // 白名单
    let whiteList = [
      '/NOIE',
      '/login',
      '/portal',
      '/school',
      '/centerManageLogin',
      '/institutionRegister',
      '/teacherinformation',
      '/teacherReviewChange',
      '/teacherReview',
      '/teacherFlexibleReview',
      '/ClassAssistant',
      '/classNotice',
    ]
    if(whiteList.includes(to.path.indexOf('/',1) > 0 ? to.path.substring(0,to.path.indexOf('/',1)) : to.path)){
      toPageFlag = true
      if (Vue.ls.get('isSchoolProject') && to.path == '/portal'){
        return next('/school/portal')
      } else {
        return next()
      }
    }
    //在没有登录的情况下，循环扫描访问的是基本布局（basicLayout）中的非白名单路由还是非基本布局（basicLayout）的白名单路由
    for (let k = 0, lens = menuPageList.length; k < lens; k++) {
      // 如果是基本布局（basicLayout）中的非白名单路，进行请求listMyPerms权限菜单，获取接口数据及处理后放行
      if (to.path == menuPageList[k].path || to.path == '/' || menuPageList[k].children && menuPageList[k].children.some(ele=>ele.path == to.path)) {
        toPageFlag = true
        routeUtilsMenthed(menuList, menuListFlag, (res) => {
          next()
        })
        break
        // 如果是非基本布局（basicLayout）的白名单路由，则直接放行
      } else {
        toPageFlag = false
      }
    }
  }

  // 如果不在路由名单中跳转到首页
  if(!toPageFlag){
    next('/portal')
  }else{
    next()
  }
})

//Duplicate named routes definition解决路由报警告的问题
router.selfaddRoutes = function (params) {
  router.matcher = new Router().matcher
  router.addRoutes(params)
}

//NavigationDuplicated {_name: "NavigationDuplicated", name: "NavigationDuplicated"}解决报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

//抽取路由处理公共方法
const routeUtilsMenthed = function (menuList, menuListFlag, callBack) {
  //1.检查有没有菜单集合和菜单列表是否处理过
  if (menuList && menuList.length > 0 && menuListFlag == true) {
    //  2.菜单是空或者数据没有处理过的情况下执行
    callBack('')
  } else {
    listMyPerms()
      .then((res) => {
        menuList = window.menuList
        if (menuList.length > 0){
          //深复制数据
          let routerTreeCopy = menuTreeData.deepClone(menuPageList)
          //处理路由菜单
          getRouterTree(menuPageList, menuList, routerTreeCopy)
          //标记菜单路由已经处理过了
          window.menuListFlag = true
          routes[0].children = routerTreeCopy
          //添加404页面
          // routes.push(
          //   {
          //     path: '*',
          //     redirect: '/exception404'
          //   })
          router.selfaddRoutes([...routes])
        }
        
        callBack(null)
      })
      .catch((error) => {
        callBack(error)
      })
  }
}

//递归循环路由处理路由数据,如果有三级四级菜单页面可以递归循环执行
const getRouterTree = function (
  routerTree,
  menuList,
  routerTreeCopy,
  deleteParentFlag
) {
  //1.做出删除菜单的标记
  for (let i = 0, lens = routerTree.length; i < lens; i++) {
    //是否需要删除上一级
    if (routerTree[i].children) {
      //如果子集有上一级不删除
      let deleteParentFlag = false
      deleteParentFlag = getRouterTree(
        routerTree[i].children,
        menuList,
        routerTreeCopy,
        deleteParentFlag
      )
      if (deleteParentFlag == true) {
        continue
      }
    }
    if (!isExist(menuList, routerTree[i].name)) {
      //  2.执行删除菜单
      deleteRouterItem(routerTreeCopy, routerTree[i].name)
    } else {
      deleteParentFlag = true
    }
  }
  return deleteParentFlag
}

//删除菜单递归
const deleteRouterItem = function (routerTreeCopy, name) {
  for (let i = 0, lens = routerTreeCopy.length; i < lens; i++) {
    if (routerTreeCopy[i].children) {
      deleteRouterItem(routerTreeCopy[i].children)
    }
    if (routerTreeCopy[i].name == name) {
      routerTreeCopy.splice(i, 1)
      return
    }
  }
}

// //在菜单集合递归查询数组是否存在
const isExist = function (menuList, routerName) {
  for (let i = 0, lens = menuList.length; i < lens; i++) {
    if (menuList[i].path == routerName) {
      return true
    } else if (menuList[i].children) {
      if (isExist(menuList[i].children, routerName)) {
        return true
      }
    }
  }
  return false
}

//  装填角色的权限菜单
const listMyPerms = function () {
  return new Promise(function (resolve, reject) {
    //  装填角色的权限菜单
    permission
      .listMyPerms()
      .then((res) => {
        if (res.data == null) {
          Vue.prototype.$message.error('服务器异常！')
        }
        for (let j = 0, lens = res.data.length; j < lens; j++) {
          menuTreeData.treeData(res.data[j], j + 1)
        }
        window.menuList = res.data
        // console.log(window.menuList,'7window.menuList')
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default router
